/**
 * Shown when the Create Administrators tool is unavailable (non-sys-admin or portal context).
 */

import Card from '../../../../../components/layouts/card/card';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import FontHeading4 from '../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR } from '../../../../../components/fonts/font-props';

const CreateAdministratorsAccessDenied: React.FC = () => {
    return (
        <Card isExpandable={false}>
            <FontHeading4>Create Administrators</FontHeading4>
            <FontBody2 color={FONT_COLOR.NEUTRAL10}>
                This tool is only available for specified system administrators.
            </FontBody2>
        </Card>
    );
};

export default CreateAdministratorsAccessDenied;
